/*
 * LegalBlink initialisation, split out of layout/theme.liquid on 2026-09-10.
 *
 * It lives in its own file for one reason only: an inline <script> cannot carry
 * the defer attribute, and the call has to run AFTER lb_cs.js. Deferred scripts
 * execute in document order, so keeping both tags deferred preserves the order
 * the inline version used to get for free.
 *
 * LegalBlink confirmed in writing (2026-09-10) that lb_cs.js uses neither
 * document.write nor document.writeln, and that the id="lb_cs" on the tag is
 * conventional rather than required.
 *
 * Do not inline this back into the layout, and do not change the site id.
 */
lb_cs("62161669f504790028a44d14");